<template>
  <div v-bind:style="barStyle">
  </div>
</template>
<script>
export default {
  name: "Colorbar",
  props: {
    barColor: String
  },
  data: function() {
    return {
      barStyle: {
        width: "80px",
        height: "3px",
        backgroundColor: this.barColor
      }
    };
  }
};
</script>